import { z } from 'zod';
import type { EditionType, BookStatus } from '../../../../shared/types/index.js';

export const formSchema = z.object({
  title: z.string().min(2, 'Judul buku minimal 2 karakter'),
  subtitle: z.string().optional(),
  originalTitle: z.string().optional(),
  authorName: z.string().min(2, 'Nama penulis wajib diisi'),
  authorWhatsapp: z.string().optional(),
  publisherName: z.string().min(2, 'Nama penerbit wajib diisi'),
  category: z.string().min(2, 'Pilih kategori buku'),
  publicationYear: z.number().int().min(1900, 'Tahun minimal 1900').max(2100, 'Tahun maksimal 2100'),
  edition: z.string().default('1'),
  editionType: z.enum(['orisinal', 'revisi', 'cetakan_baru', 'digital', 'terjemahan', 'edisi_khusus', 'edisi_saku']).default('orisinal'),
  editionNotes: z.string().optional(),
  pages: z.number().int().nonnegative('Jumlah halaman tidak boleh negatif').default(0),
  language: z.string().default('Indonesia'),
  isbnOriginal: z.string().optional(),
  synopsis: z.string().optional(),
  tableOfContents: z.string().optional(),
  coverUrl: z.string().optional(),
  purchaseUrl: z.string().optional(),
  status: z.enum(['draft', 'diajukan', 'disetujui', 'diarsipkan', 'menunggu_penerbit']).default('diajukan'),
  selectedPublisherId: z.string().optional(),
  selectedPublisherName: z.string().optional(),
  selectedPublisherCode: z.string().optional(),
});

export const CATEGORIES = [
  'Fiksi & Sastra',
  'Sains & Teknologi',
  'Bisnis & Ekonomi',
  'Sejarah & Budaya',
  'Pengembangan Diri',
  'Pendidikan & Akademik',
  'Agama & Filosofi',
  'Seni & Desain',
  'Komik & Grafis',
  'Anak & Remaja',
];

export interface BookFormData {
  title: string;
  subtitle: string;
  originalTitle: string;
  authorName: string;
  authorWhatsapp?: string;
  publisherName: string;
  category: string;
  publicationYear: number;
  edition: string;
  editionType: EditionType;
  editionNotes: string;
  pages: number;
  language: string;
  isbnOriginal: string;
  synopsis: string;
  tableOfContents?: string;
  coverUrl: string;
  purchaseUrl: string;
  status: BookStatus;
  selectedPublisherId?: string;
  selectedPublisherName?: string;
  selectedPublisherCode?: string;
}
